import Offcanvas from 'react-bootstrap/Offcanvas';
import OffCanvasCloseBtn from 'components/offcanvas/OffCanvasCloseBtn';

import FilterInput from 'components/FilterInput';
import { useFilterBuilding, useFilterOrganization } from 'hooks/useFilterInput';
import { useEffect, useState } from 'react';
import axios from 'axios';
import OrganizationItem from 'components/OrganizationItem';
import ViewBuildingItem from 'components/ViewBuildingItem';
import { useNavigate } from 'react-router';
import OffCanvasBackBtn from 'components/offcanvas/OffCanvasBackBtn';
import { IoAdd, IoCameraOutline,IoChevronForward } from 'react-icons/io5';
import moment from 'moment';
import { Button } from 'react-bootstrap';


function useOffCanvasAddOrgAppointment(props) {

    const {
        show,
        organizationSelected,
    } = props;

    const [organizations, setOrganizations] = useState();
    const [products, setProducts] = useState();
    const [buildings, setBuildings] = useState();

    // navigation handled elsewhere; when clicking a building we'll trigger
    // the service organization flow via the parent `handleSelectServiceOrganization` prop

    useEffect(() => {
        if (!show || organizations) return;

        axios.get('organizations')
        .then(res => setOrganizations(res.data));
    
    }, [show, organizations]);

    useEffect(() => {
        if (!show || show !== 'GENERIC' || products) return;

        axios.get('products', {
            params: {
                type: 'GENERIC',
            }
        })
        .then(res => setProducts(res.data));

    }, [show, products]);

    useEffect(() => {
        setBuildings();
        if (!organizationSelected) return;

        axios.get('buildings', {
            params: {
                organization_id: organizationSelected.id,
                status: 'RESERVABLE'
            }
        })
            .then(res => setBuildings(res.data))
    }, [organizationSelected]);

    return {
        organizations,
        buildings,
        products
    }
}



export default function OffCanvasAddAppointment(props) {

    const {
        show,
        handleClose,
        handleSelectOrganization,
        handleSelectServiceOrganization,
        organizationSelected,
        handleNewBuilding,
        resourceInfo,
    } = props;

    const {
        organizations,
        buildings,
        products
    } = useOffCanvasAddOrgAppointment(props);

    const [filterInputOrganization, handleFilterOrganization, searchArrayOrganization, setFilterInputOrganization, setFilterInputOrganizationAndUrl] = useFilterOrganization();
    const [filterInputBuilding, handleFilterBuilding, searchArrayBuilding , setFilterInputBuilding ] = useFilterBuilding();

    const filteredBuildings = buildings?.filter(searchArrayBuilding);
    const filteredOrganizations = organizations?.filter(searchArrayOrganization);
    const navigate = useNavigate();

    useEffect(() => {
        if(organizationSelected){
                    setFilterInputBuilding('');
        }
    }, [organizationSelected]);

    useEffect(() => {
        if(!show) {
            setFilterInputOrganizationAndUrl('');
            setFilterInputBuilding('');
        }
    }, [show]);

    console.log('render OffCanvasAddOrgAppointment', buildings);

    return (<>
        <Offcanvas placement="bottom" style={{minHeight: "90vh"}} className="action-sheet" show={!!resourceInfo && show} onHide={handleClose}>
            <Offcanvas.Body>
                {organizationSelected && <OffCanvasBackBtn handleBack={() => handleSelectOrganization()} />}
                <OffCanvasCloseBtn handleClose={handleClose} />
                <div className="section mt-3 text-center">
                    <h3>Nuova prenotazione</h3>
                </div>
                <div className="action-sheet-content py-2 px-1">
                    {(!organizationSelected || show === 'BUILDING' || show === 'SERVICE') && (
                        <FilterInput
                            placeHolder={`Ricerca ${organizationSelected ? 'immobile' : 'attività'}`}
                            onChange={organizationSelected ? handleFilterBuilding : handleFilterOrganization}
                            value={organizationSelected ? filterInputBuilding : filterInputOrganization}
                        />
                    )}
                    <ul className="listview image-listview text no-border">
                        {!organizationSelected ? <>
                            {!organizations && Array(5).fill(null).map((_, i) => <OrganizationItem key={i} isSkeleton />)}
                            {organizations && organizations.filter(searchArrayOrganization).map(organization => (
                                <OrganizationItem
                                    key={organization.id}
                                    organization={organization}
                                    isList
                                    onClick={() => handleSelectOrganization(organization)}
                                />
                            ))}
                            {filteredOrganizations && !filteredOrganizations?.length &&
                                <li>
                                    <div className="text-center py-5 px-4">
                                        Non è stata trovata nessuna attività con questo nome
                                    </div>
                                </li>
                            }
                        </> : (show === 'GENERIC' ? (<>
                            {products && products.map(product => (
                                <li onClick={() => navigate(`/personal-brand/${product.id}?date=${moment(resourceInfo.date).format('YYYY-MM-DD')}&ph=${resourceInfo?.resource.extendedProps.uid}&org_id=${organizationSelected.id}`)} key={product.id}>
                                    <a className="item">
                                        <div className={`icon-box bg-secondary`}>
                                            <IoCameraOutline />
                                        </div>
                                        <span>{product.description}</span>
                                    </a>
                                </li>
                            ))}
                           </>) : (
                            <>
                                <li onClick={handleNewBuilding}>
                                    <a className="item no-after">
                                        <div className="icon-box bg-success">
                                            <IoAdd />
                                        </div>
                                        <div className="in text-success">
                                            <div className="fw-500">Aggiungi immobile</div>
                                        </div>
                                    </a>
                                </li>
                                {!buildings && Array(5).fill(null).map((_, i) => <ViewBuildingItem key={i} isSkeleton />)}
                                {filteredBuildings?.map(building => <ViewBuildingItem
                                    key={building.id}
                                    building={building}
                                    handleClickDetail={() => handleSelectServiceOrganization(organizationSelected, building)}
                                />)}
                                {filteredBuildings && !filteredBuildings?.length &&
                                    <li>
                                        <div className="text-center py-5 px-4">
                                            Non è stata trovata nessuna immobile con questo nome
                                        </div>
                                    </li>
                                }
                            </>)
                        )}
                    </ul>
                   
                </div>
            </Offcanvas.Body>

                {show === 'SERVICE' && buildings && (
                    <div className="action-sheet-footer bg-primary text-white cursor-pointer align-items-center d-flex justify-content-center gap-2 p-1" onClick={() => handleSelectServiceOrganization(organizationSelected, null)}>
                        Salta Selezione Immobile
                        <IoChevronForward />
                    </div>
                )}

        </Offcanvas>
    </>);

}